import styled from '@emotion/styled'
import tw from 'twin.macro'

export const TopHeroBackground = styled.div`
  ${tw`
    absolute
    top-0
    w-full
    bg-cover
  `}
  svg {
    @media (max-width: 374px) {
      &.mobile-background {
        ${tw`
          block
          w-full
        `}
      }
      &.desktop-background {
        ${tw`
          hidden
        `}
      }
    }
    @media (min-width: 375px) {
      &.mobile-background {
        ${tw`
          block
          w-full
        `}
      }
      &.desktop-background {
        ${tw`
          hidden
        `}
      }
    }
    @media (min-width: 768px) {
      &.mobile-background {
        ${tw`
          hidden
        `}
      }
      &.desktop-background {
        ${tw`
          block
          w-full
        `}
      }
    }
  }
  mix-blend-mode: color-burn;
`

export const BottomHeroBackground = styled.div`
  ${tw`
    absolute
    w-full
    h-screen
    bg-cover
    top-0
  `}
  svg {
    @media (max-width: 374px) {
      &.mobile-background {
        ${tw`
          block
          w-full
        `}
      }
      &.desktop-background {
        ${tw`
          hidden
        `}
      }
    }
    @media (min-width: 375px) {
      &.mobile-background {
        ${tw`
          block
          w-full
        `}
      }
      &.desktop-background {
        ${tw`
          hidden
        `}
      }
    }
    @media (min-width: 768px) {
      &.mobile-background {
        ${tw`
          hidden
        `}
      }
      &.desktop-background {
        ${tw`
          block
          w-full
        `}
      }
    }
  }
  mix-blend-mode: color-burn;
`

export const MiddleHeroBackground = styled.div`
  ${tw`
    absolute
    inset-y-1/3
    bg-cover
    w-full
  `}
  @media (min-width: 374px) {
    .enterprise-connections-background {
      transform: translateY(350px);
    }
  }
  @media (min-width: 768px) {
    .enterprise-connections-background {
      transform: translateY(200px);
    }
  }
  svg {
    ${tw`
      w-full
    `}
    @media (max-width: 374px) {
      &.mobile-background {
        ${tw`
          block
        `}
      }
      &.desktop-background {
        ${tw`
          hidden
        `}
      }
    }
    @media (min-width: 375px) {
      &.mobile-background {
        ${tw`
          block
        `}
      }
      &.desktop-background {
        ${tw`
          hidden
        `}
      }
    }
    @media (min-width: 768px) {
      &.mobile-background {
        ${tw`
          hidden
        `}
      }
      &.desktop-background {
        ${tw`
          block
        `}
      }
    }
  }
  mix-blend-mode: color-burn;
`
